import styles from './AboutPage.module.css';
import jtPhoto from './jt-photo.png';

function AboutPage() {
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>About JT</h1>
      <img src={jtPhoto} alt="JT" className={styles.avatar} />
      <div className={styles.bio}>
        <p>
          Hi! I'm JT, and I love making art. I use paint, markers, colored pencils,
          and pretty much anything I can get my hands on to create colorful pictures
          of the things I imagine.
        </p>
        <p>
          My favorite things to draw are dragons, animals in space, underwater worlds,
          and giant flowers. Every piece is made with lots of love and creativity.
        </p>
        <p>
          When you buy one of my artworks, you're getting a real, original piece
          that I made just for you. Thanks for visiting my gallery!
        </p>
      </div>
    </div>
  );
}

export default AboutPage;
